export const WACS_Payment_Modes =
Object.freeze ({
    'Free': 'FREE',
    'Charged': 'CHARGED'
});